import Vue from "vue";
import Vuex from "vuex";
import key from "./modules/token/key";
import register from "./modules/token/register";
import projects from "./modules/projects";
import tasks from "./modules/tasks";
import comments from "./modules/comments";
import files from "./modules/files";
import history from "./modules/history";
import chats from "./modules/chats";
import { EventEmitter } from "../main";
import alert from "@/utils/alert";
import actionListChat from "@/utils/actionListChat";
import { authFetch, refreshAuthToken } from "@/utils/auth";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    message: {
      key_message: "",
      message: "",
    },
    alertMessage: {},
    lastActionListChat: null,
    reconnection_count: 0,
    app_loader: false,
    applicationStatus: "updated",
  },
  mutations: {
    setMessage(s, v) {
      s.message = v;
    },
    clearMessage(s) {
      s.message = "";
    },
    changeReconnectionCount(s, v) {
      s.reconnection_count = v;
    },
    offAppLoader(s, v) {
      setTimeout(() => {
        s.app_loader = false;
      }, 500);
    },
    onAppLoader(s, v) {
      s.app_loader = true;
    },
    setApplicationStatus(s, v) {
      s.applicationStatus = v;
    },
    setAlertMessage(s, v) {
      s.alertMessage = v;
    },
    clearAlertMessage(s) {
      s.alertMessage = {};
    },
    setLastActionListChat(s, v) {
      s.lastActionListChat = v;
    },
  },
  actions: {
    async fetch_request(
      { dispatch, getters, commit },
      { token, method, url, body, skipTokenRefresh = false }
    ) {
      const controller = new AbortController();
      const signal = controller.signal;

      let headers = {};

      if (token) {
        headers = {
          Code: "web777",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("w_token"),
        };
      } else {
        headers = {
          "Content-Type": "application/json",
          Code: "web777",
        };
      }

      headers.lang = localStorage.getItem("language") || "en";

      if (url.includes("/api/users/data")) {
        EventEmitter.$emit("fetchRequestController", controller);
      }

      const requestBody = body ? JSON.stringify(body) : null;

      const requestOptions = {
        method,
        headers,
        body: requestBody,
        signal,
      };

      const res = token
        ? await authFetch(url, requestOptions, { retryOn401: false })
        : await fetch(url, requestOptions);

      if (res.ok) {
        if (!res.url.includes("/autorisation")) {
          commit("changeReconnectionCount", 0);
        }
        return res;
      } else {
        if (token && res.status === 401 && !skipTokenRefresh) {
          if (getters.getReconnectionCount == 2) {
            commit("changeReconnectionCount", 0);
            return res;
          }

          commit("changeReconnectionCount", getters.getReconnectionCount + 1);

          const has_new_token = await refreshAuthToken();

          if (has_new_token) {
            return await dispatch("fetch_request", {
              token,
              method,
              url,
              body,
              skipTokenRefresh,
            });
          }
        }

        commit("changeReconnectionCount", 0);
        return res;
      }
    },

    SOCKET_OUT_AlertMessage({ commit }, data) {
      const buttons = (data.buttons || []).map((btn) => {
        return {
          buttonText: btn.label,
          className:
            btn.style === "danger"
              ? "red"
              : btn.style === "default"
              ? ""
              : btn.style || "",
          callback: (close) => {
            // Cancel/Close → только закрываем
            if (btn.type == "close" || btn.type == "cancel") {
              close();
              return;
            }

            // Action → отправляем на backend
            if (btn.type == "action") {
              if (data.action_key === "IN_ActionListChat:updateUsers") {
                actionListChat.approvePendingUpdateUsers(this._vm.$socket);
              } else if (data.action_key == "ff") {
              }
              close();
            }
          },
        };
      });

      this._vm.$w_alert(data.text || "", buttons);
    },
    SOCKET_OUT_ActionListChat({ commit }, data) {
      commit("setLastActionListChat", data);
    },
    SOCKET_OUT_Message({ commit }, data) {
      // console.log("SOCKET_OUT_Message in store: ", data);
      const er = {
        key_message: "warning",
        message: data.Message ? data.Message : data,
        upgrade_text: data.upgrade_text,
        plan: data.plan ? true : false,
        redirect: data.redirect ? data.redirect : false,
      };
      if (data.key == "ProjectAll") {
        commit("setProjects", []);
      }
      if (data.key == "TaskAll") {
        commit("setTasks", []);
      }
      if (data.key == "TaskAdd") {
        er.key_message = "success";
      }
      if (data.key == "ProjectAdd") {
        er.key_message = "success";
      }
      commit("setMessage", er);
    },
  },
  getters: {
    getAlertMessage: (s) => s.alertMessage,
    getMessage: (s) => s.message,
    getLastActionListChat: (s) => s.lastActionListChat,
    getReconnectionCount: (s) => s.reconnection_count,
    getAppLoader: (s) => s.app_loader,
    getApplicationStatus: (s) => s.applicationStatus,
  },
  modules: {
    key,
    register,
    projects,
    tasks,
    comments,
    files,
    history,
    chats,
  },
});
